import { Routes } from "#/routes";
import { useOidc, useOidcAccessToken } from "@axa-fr/react-oidc";
import { Meta } from "@sicredi/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { StrictMode, useEffect } from "react";
import { hot } from "react-hot-loader/root";

export const App: React.FC = () => {
  const { accessToken, accessTokenPayload } = useOidcAccessToken();
  const { logout } = useOidc();

  useEffect(() => {
    window.auth = {
      ...window.auth,
      user: accessTokenPayload,
      get token() {
        return accessToken;
      },
    };
  }, [accessToken, accessTokenPayload]);

  useEffect(() => {
    window.auth = {
      ...window.auth,
      actions: { logout },
    };
  }, [logout]);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        retry: false,
      },
    },
  });

  return (
    <>
      <Meta titleTemplate="%s - Sicredi" defaultTitle="Sicredi" />

      <main>
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <Routes />
          </QueryClientProvider>
        </StrictMode>
      </main>
    </>
  );
};

export default hot(App);
